import { bindable, autoinject } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';


@autoinject()
export class PropertyWidget {
	editModeChangedSubscription: Subscription;

	constructor(
		private eventAggregator: EventAggregator
	) {
		this.eventAggregator.subscribe(AppEvents.EDIT_MODE_CHANGED, (mode) => this.editModeChanged(mode));
	}

	attached() {
		this.editModeChangedSubscription = this.eventAggregator.subscribe(AppEvents.EDIT_MODE_CHANGED, (mode) => this.editModeChanged(mode));
	}

	detached() {
		this.editModeChangedSubscription.dispose();
	}

	editModeChanged(mode: string) {
		if (mode === "EDIT_MODE") {
			this.showEditContent = true;
			this.showEditIcon = false;
			this.showSaveIcon = false;
		}

		if (mode === "VIEW_MODE") {
			this.showEditContent = false;
			this.showSaveIcon = false;
			this.showEditIcon = true;
		}
	}

	@bindable editable: boolean = true;
	@bindable save: Function;
	@bindable cancel: Function;
	@bindable validate: Function;
	showEditContent = false;
	showEditIcon = true;
	showSaveIcon = false;
	//showIcons = false;
	editProperty() {
		this.showEditContent = true;
		this.showSaveIcon = true;
		this.showEditIcon = false;

	}

	cancelPropertyEdit() {
		this.showEditContent = false;
		this.showEditIcon = true;
		this.showSaveIcon = false;
		this.cancel();
	}

	async savePropertyEdit() {
		
		let isValid: boolean = true; 
		if (this.validate) {
			isValid = await this.validate();
		}
		if (isValid) {
			this.showEditContent = false;
			this.showEditIcon = true;
			this.showSaveIcon = false;
			this.save();
		}
	}
}
